module.exports = __webpack_public_path__ + "1ace961377306f106345856f120ede0e.svg";